module.exports = __webpack_public_path__ + "static/media/linee.c2ba37d3.svg";